import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AuthorizedGuard } from './auth/guards/authorized.guard';
import { ExternalAuthorizeGuard } from './auth/guards/external-authorize.guard';
import { ToLoginGuard } from './auth/guards/to-login.guard';
import { ToPerfilGuard } from './auth/guards/to-perfil.guard';
import { LandingPageGuard } from './landing-page/landing-page.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  }, {
    path: 'dashboard',
    canActivate: [ToLoginGuard, ToPerfilGuard],
    canActivateChild: [AuthorizedGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'external',
    canActivateChild: [ExternalAuthorizeGuard],
    loadChildren: () => import('./external/external.module').then(m => m.ExternalModule)
  },
  {
    path: 'landingpage',
    canActivate: [LandingPageGuard],
    loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule)
  },
  {
    path: '404NotFound',
    loadChildren: () => import('./not-found404/not-found404.module').then(m => m.NotFound404Module)
  },
  {
    path: '**',
    redirectTo: '/landingpage'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
